import { tokenStore } from "../api/token";

export function ForbiddenPage({
  email,
  message,
}: {
  email?: string;
  message?: string;
}) {
  return (
    <div className="auth-splash">
      <div className="auth-splash-card">
        <div className="auth-splash-title">Доступ закрыт</div>
        <div className="auth-splash-sub">
          {message ??
            (email
              ? `У аккаунта ${email} нет прав на эту страницу.`
              : "У этого аккаунта нет прав на эту страницу.")}
        </div>
        <button
          className="auth-splash-action"
          onClick={() => {
            tokenStore.clear();
            window.location.href = "/login";
          }}
        >
          Войти другим аккаунтом
        </button>
      </div>
    </div>
  );
}
